<template>
  <div class="v2-test" data-qid="test-form-v2">
    <b-alert v-if="formError" show variant="danger">{{ formError }}</b-alert>

    <section class="v2-test__section">
      <label class="v2-test__label" for="test-form-name">
        {{ $t('tasks.v2.test_name') }} <span class="text-red">*</span>
      </label>
      <b-form-input id="test-form-name"
                    v-model="testForm.name"
                    :maxLength="255"
                    :placeholder="$t('tasks.v2.test_name_placeholder')"
                    data-qid="test-form-name"
      ></b-form-input>
    </section>

    <section class="v2-test__section">
      <label class="v2-test__label" for="test-form-description">
        {{ $t('tasks.v2.what_client_provides') }} <span class="text-red">*</span>
      </label>
      <b-form-textarea id="test-form-description"
                       v-model="testForm.description"
                       rows="4"
                       max-rows="10"
                       :placeholder="$t('tasks.v2.test_description_placeholder')"
                       data-qid="test-form-description"
      ></b-form-textarea>
    </section>

    <section v-for="setting in settings" :key="'setting-' + setting.key" class="v2-test__section">
      <div class="v2-test__label">{{ setting.label }}</div>
      <div class="task-choices">
        <span v-for="option in allowTypes"
              :key="setting.key + '-' + option.value"
              class="task-choice"
              :class="['task-choice--' + tone(option.value), {'task-choice--on': selected(setting.key) === option.value}]"
              @click="testForm[setting.key] = option"
              :data-qid="'test-form-' + setting.key + '-' + option.value"
        >
          <font-awesome-icon :icon="selected(setting.key) === option.value ? 'dot-circle' : 'circle'"/>{{ option.name }}
        </span>
      </div>
      <div class="v2-test__hint v2-test__hint--muted">{{ setting.hint }}</div>
    </section>

    <div class="v2-modal__foot">
      <b-button variant="secondary" @click="cancel" data-qid="test-form-cancel">{{ $t('projects.create.cancel') }}</b-button>
      <b-button variant="success"
                :disabled="buttonDisabled"
                @click="submit"
                data-qid="test-form-submit"
      >
        {{ mode === 'create' ? $t('tasks.v2.create_test') : $t('tasks.v2.save_test') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';

// New / edit test (sample) on engagements: name, what the client must provide, and whether the
// client's answer and files are optional or mandatory
export default {
  name: 'EngagementTestForm',
  mixins: [assessmentSingleTaskProxy],
  props: {
    mode: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      formError: ''
    };
  },
  computed: {
    settings() {
      return [
        { key: 'allow_description', label: this.$t('tasks.v2.client_answer_setting'), hint: this.$t('tasks.v2.client_answer_setting_hint') },
        { key: 'allow_attachment', label: this.$t('tasks.v2.client_files_setting'), hint: this.$t('tasks.v2.client_files_setting_hint') }
      ];
    }
  },
  methods: {
    selected(key) {
      return this.testForm[key] && this.testForm[key].value;
    },
    tone(value) {
      return { No: 'grey', Optional: 'teal', Mandatory: 'amber' }[value];
    },
    cancel() {
      this.formError = '';
      if (this.mode === 'create') {
        this.hideEditTestModal();
      } else {
        this.hideUpdateTestModal();
      }
    },
    submit() {
      this.formError = '';
      if (!(this.testForm.name || '').trim() || !(this.testForm.description || '').trim() || !this.selected('allow_description') || !this.selected('allow_attachment')) {
        this.formError = this.$t('tasks.v2.test_form_required');
        return;
      }
      const evt = { preventDefault() {} };
      if (this.mode === 'create') {
        this.createTestFormSubmit(evt);
      } else {
        this.updateTestFormSubmit(evt);
      }
    }
  }
};
</script>
